module.exports = __webpack_public_path__ + "img/BRP.ef3ef01b.svg";